import { Box, Stack } from "@mui/material";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AccessDenied from "../../../components/error/AccessDenied";
import Loading from "../../../components/Loading/loading";
import NoDataComponent from "../../../components/nodata/nodata";
import Page from "../../../components/Page"
import { pageVariables } from "../../../components/siteBuilder/siteBuilderVariables";
import { defaultPageJson } from "../../../config/defaultValues";
import { reduxHelper } from "../../../config/reduxHelper";
import { getDynamicJson } from "../../../functions/getDynamicJson";
import { getString } from "../../../functions/getString";
import { useProfile } from "../../../hooks/useProfile";
import { useSinglePage } from "../../../hooks/useSinglePage";
import { useUser } from "../../../hooks/useUser";
import { dynamicComponents } from "../../../siteThemes/components";
import Page404 from "../../404";
import Cookies from 'js-cookie'
import MessagePage from "../../../components/MessagePage/MessagePage"
import useDevice from "../../../hooks/useDevice";

const Pages = ({ is404, ...props }) => {
    
    const { query, ...others } = useRouter()

    const [pageJson, setPageJson] = useState([])
    const [value, setValue]       = useState(false)
    const [isLoading, setLoading] = useState(true)
    const [pageId, setPageId]     = useState('')
    const [isAdmin, setisAdmin]     = useState(false)
    const [showPermissionDenied, setShowPermissionDenied] = useState(false)
    const [pageNotAvailable, setPageNotAvailable] = useState(false);
    const { reducer } = useSelector((state) => state);
    const { layoutJson, authLoading, user, appData} = reducer;
    const [direction, setDirection] = useState(null)

    const {isMobile, isTablet} = useDevice();

    // const getProfile = async() =>{
    //     const result = await useProfile()
        
    // }

    // useEffect(() =>{
    //     getProfile()
    // }, [])

    const dispatch = useDispatch();

    const getUserData = async() =>{
        const result = await useProfile()
        setisAdmin(result?.us_role_id == '1')
        
    }

    

    useEffect(() =>{
        getUserData()
    }, [])    

    const getPageData = async () => {


        try{

            const result                = await useSinglePage(query?.slug)
            if ( query?.preview == 1 && query?.slug == 'contact-us')
                {
                    const data = await fetch (`${appData?.account_url}/assets/siteBuilderTemplates/site_template1/defaultContactUsTemplate1.json`)

                    const defaultContactUsTemplate1 = await data.json();
                    
                    setPageJson(defaultContactUsTemplate1)
                    dispatch({
                        type: reduxHelper.UPDATE_PAGE_JSON,
                        payload : defaultContactUsTemplate1
                    })
                }
            else if(query?.preview == 1 && query?.slug == 'about-us'){

                const data = await fetch (`${appData?.account_url}/assets/siteBuilderTemplates/site_template1/defaultAboutUsTemplate1.json`)

                const defaultTemplate1ContactUsJson = await data.json()

                setPageJson(defaultTemplate1ContactUsJson);
                dispatch({
                    type : reduxHelper.UPDATE_PAGE_JSON,
                    payload : defaultTemplate1ContactUsJson,
                })
            }

            
            else if(typeof result?.categories === 'object' && Object.keys(result?.categories).length > 0)
            {

                const globalLang = Cookies.get("ldfinweaklsdfj");
                
                const encodedGlobalLang = globalLang ? globalLang : "en"

                const langSuffix = !globalLang || encodedGlobalLang == "en" ? result?.categories[0]?.id : `${result?.categories[0]?.id}-${encodedGlobalLang}`
                // setLoading(true) 
                setPageNotAvailable(false);
                const url                   = result?.path + 'site_builder/pages/' + langSuffix + '.json?v=' + Math.random()
                setPageId(result?.categories[0]?.id)
                const pageJsonResponse      = await fetch(url);
                const response              = await pageJsonResponse.json();                

                let stringedPageData = JSON.stringify(response)

                for(let x in pageVariables)
                {
                    if(result?.categories[0][x])
                    {
                        stringedPageData = stringedPageData?.replace(pageVariables[x], result?.categories[0][x])
                    }
                }

                const parsedJson = JSON.parse(stringedPageData);

                console.log(parsedJson, "parsedJson");
                

                let obj = {}
                const headerData = parsedJson?.components?.filter((i) => i.name == 'Header'||i.name === 'Footer')
                obj['components'] = headerData
                obj['isDefault'] = true
                obj['type'] = 'layout';

                dispatch({
                    type: reduxHelper.UPDATE_LAYOUT_JSON,
                    payload: obj
                })


                const pageJsonData = getDynamicJson(parsedJson, obj)
                setPageJson(pageJsonData)

                dispatch({
                    type: reduxHelper.UPDATE_THEME_BUILDER_JSON,
                    payload: pageJsonData
                })

                dispatch({
                    type: reduxHelper.UPDATE_PAGE_JSON,
                    payload: pageJsonData
                })

                // setLoading(false);
            }
            else
            {
                setPageNotAvailable(true);
                setLoading(false)
            }
        }
        catch (error) {
            setPageNotAvailable(true);
            setLoading(false);
            console.log(error)
        }finally{
            setLoading(false);
        }
       
    }

//     const getPageData = async () => {
        
//         const result                = await useSinglePage(query?.slug)
//         const url                   = result?.path + 'site_builder/pages/' + result?.categories[0]?.id + '.json?v=' + Math.random()
//        const pageJsonResponse       =  await fetch(url);
//        const response               = await pageJsonResponse.json();
       

// //   console.log(typeof window.globalUserData,window.globalUserData)
//     //    if(response?.needLogin === true &&  user == null)
//     //    {

//     //     console.log(response,'response',user)

//     //        let accessDeniedData = {}
//     //        accessDeniedData['title']   = getString('Access Denied');
//     //        accessDeniedData['heading'] = getString('please login');
//     //        dispatch({
//     //            type: reduxHelper.UPDATE_ACCESS_DENIED,
//     //            payload: accessDeniedData
//     //        })
//     //        setShowPermissionDenied(true)
//     //        setLoading(false)
//     //    }
//     //    else
//     //    {

//            let stringedPageData = JSON.stringify(response)

//            for(let x in pageVariables)
//            {
//                if(result?.categories[0][x])
//                {
//                    stringedPageData = stringedPageData?.replace(pageVariables[x], result?.categories[0][x])
//                }
//            }

           

//            const parsedJson = JSON.parse(stringedPageData);

//            let obj = {}
//            const headerData = parsedJson?.components?.filter((i) => i.name == 'Header')
//            obj['components'] = headerData
//            obj['isDefault'] = true
//            obj['type'] = 'layout';

//            dispatch({
//             type: reduxHelper.UPDATE_LAYOUT_JSON,
//             payload: obj
//            })


//            const pageJsonData = getDynamicJson(parsedJson, obj)
//            setPageJson(pageJsonData)

//            dispatch({
//                type: reduxHelper.UPDATE_THEME_BUILDER_JSON,
//                payload: pageJsonData
//            })
//            dispatch({
//                type: reduxHelper.UPDATE_PAGE_JSON,
//                payload: pageJsonData
//            })

//            setLoading(false);

//     //    }
//             // .then((res) => (res.json()))
//             // .then((response) => {

                

               
//             // })
//             // .catch((error) => {
//             //     console.log(error)
//             // })
//     }

    useEffect(() => {
        getPageData()
    }, [query?.slug])



    useEffect(() => {
        const isMobileApp = query?.is_mobile_app === '1';
        const lang = query?.lang;

        if (isMobileApp && (lang === 'ur' || lang === 'ar')) {
            setDirection('rtl');
        } else {
            setDirection(null);
        }
    }, [query?.lang, query?.is_mobile_app]);

    if(isLoading){
        return <Loading/>
    }

    if(is404 && !query?.preview == "1")
    {
        return <Page404 fromPages = {true} admin={isAdmin}/>
    }else if(pageNotAvailable){
        
        return <MessagePage id={pageId} admin={isAdmin}/>
    }

   

    // if(pagesHide?.active != 1)
    // {
    //     return <AccessDenied/>
    // }

    // if(!isLoading && value == true)
    // {
    //     return <AccessDenied/>
    // }

    const components = pageJson?.components?.map((item) => {
        return dynamicComponents[item.key]
    });

    return (
        <Page title={pageJson ? pageJson?.page_name : 'Page'} {...(direction ? { dir: direction } : {})} >

            <Stack 
                style={{
                        ...pageJson?.pageStyle,
                        gap: undefined,
                        paddingLeft: isMobile || isTablet ? 2 :  pageJson?.pageStyle?.paddingLeft,
                        paddingRight: isMobile || isTablet ? 2:  pageJson?.pageStyle?.paddingRight,
                    }}
            >
                {
                    components?.map((item, index) => {
                        const Component = item;
                        return (
                            <Component/>
                        )
                    })
                }
            </Stack>
        
            

        </Page>
    )
};

export default Pages;


export async function getServerSideProps ({ req, res, query })
{

    const slug      = query?.slug;
    
    const host      = req.headers.host === 'localhost:3000' ? 'saas.devekhool.com' : req.headers.host;
    const protocal  = req.headers['x-forwarded-proto'] || host == 'saas.devekhool.com' ? 'https://' : 'http://';
    const url       = protocal + host + process.env.API_SLUG + 'pages?slugs=' + slug + '&single=true';

    const response     = await fetch(url);
    const jsonResponse = await response.json();


    let jsonPath = ''
    const layoutPath = jsonResponse?.path + 'site_builder/layout/bGF5b3V0.json?v=' + Math.random()

    if(!jsonResponse.error && jsonResponse?.categories?.length > 0)
    {
        jsonPath = jsonResponse?.path + 'site_builder/pages/' + jsonResponse?.categories[0]?.id + '.json?v=' + Math.random()
    }
    else
    {
        // props['is404'] = true

        return {
            props: {
                is404: true,
                componentData: []
            }
        }
    }
    

    let pageJson = {}

    try 
    {

        const pageJsonResult    = await fetch(jsonPath);
        pageJson = await pageJsonResult.json()

    } 
    catch (error) 
    {

        pageJson = defaultPageJson
        
    }

    return {
        props: {
            componentData: pageJson,
            pageData: jsonResponse?.categories[0]
        }
    }
}